export default __webpack_public_path__ + "assets/images/a9b7f29d37745323ae635f43fc95ecd4.svg";